import cx from 'classnames';
import React, {useContext} from 'react';
import {Space} from 'antd';
import {useRouter} from 'next/router';
import dynamic from 'next/dynamic';
import DivisionLine from '@/components/DivisionLine';
import HeaderInput from '@/components/NavigationHeader/HeaderInput';
import HeaderLogin from '@/components/NavigationHeader/HeaderLogin';
import {NavigationHeaderContext} from '@/components/NavigationHeader/NavigationHeaderContext';
import HeaderNavItemConsole from '@/components/NavigationHeader/HeaderNavItemConsole';

const HeaderNavItemOnlyClient = dynamic(() => import('@/components/NavigationHeader/HeaderNavItem'),{ ssr: false });

const PcHeader = () => {
  const NavigationHeaderContextProps = useContext(NavigationHeaderContext);
  const {
    activeMenuTitleOnClick,
    onSiteNameClick,
    siteName,
    activeMenuTitle,
    onLogoClick,
  } = NavigationHeaderContextProps;
  // 获取路由
  const router = useRouter();

  return (
    <div className="dr-nav">
      <DivisionLine gap={8} lineClassName="dr-nav-line">
        <div
          className={cx('dr-nav-logo', onLogoClick && 'dr-nav-click')}
          onClick={() => {
            onLogoClick?.();
          }}
        >
          <img
            alt="logo"
            src="https://hwobs.fanruan.com/ui/digit-fe/header/fine_logo_dynamic.gif"
          />
        </div>
        <Space size={32}>
          <div
            className={cx(
              'dr-nav-title',
              (onSiteNameClick || activeMenuTitleOnClick) && 'dr-nav-click',
            )}
            onClick={(e) => {
              e.stopPropagation();
              onSiteNameClick?.();
              if (!siteName) {
                activeMenuTitleOnClick?.();
              }
            }}
          >
            {siteName || activeMenuTitle}
          </div>
          {[
            '/console/cheat',
            '/console/noCheck',
            '/console/text',
            '/console/access',
          ].includes(router.pathname) ? (
            <HeaderNavItemConsole />
          ) : (
            <HeaderNavItemOnlyClient />
          )}
        </Space>
      </DivisionLine>

      <HeaderInput />

      <HeaderLogin />
    </div>
  );
};
export default PcHeader;
